import { ArrayUtils, MGPMap, MGPOptional, NumberMap, Utils } from '@everyboard/lib';
import { Player } from '../../jscaip/Player';
import { PlayerMap } from '../../jscaip/PlayerMap';
import { GameStateWithTable } from '../../jscaip/state/GameStateWithTable';
import { EncapsulePiece } from './EncapsulePiece';
export class EncapsuleRemainingPieces extends PlayerMap {
}
export class EncapsuleSizeToNumberMap extends NumberMap {
}
export class EncapsuleState extends GameStateWithTable {
    remainingPieces;
    nbOfPieceSize;
    constructor(board, turn, remainingPieces, nbOfPieceSize) {
        super(board, turn);
        this.remainingPieces = remainingPieces;
        this.nbOfPieceSize = nbOfPieceSize;
        this.remainingPieces.get(Player.ZERO).makeImmutable();
        this.remainingPieces.get(Player.ONE).makeImmutable();
        this.remainingPieces.makeImmutable();
    }
    getRemainingPiecesCopy() {
        const playerZeroValue = this.remainingPieces.get(Player.ZERO).getCopy();
        const playerOneValue = this.remainingPieces.get(Player.ONE).getCopy();
        playerZeroValue.makeImmutable();
        playerOneValue.makeImmutable();
        return PlayerMap.ofValues(playerZeroValue, playerOneValue);
    }
    getRemainingPiecesOfPlayer(player) {
        return this.getRemainingPiecesCopy().get(player);
    }
    pieceBelongsToCurrentPlayer(piece) {
        return piece.belongsTo(this.getCurrentPlayer());
    }
    isDroppable(piece) {
        return this.pieceBelongsToCurrentPlayer(piece) &&
            this.isInRemainingPieces(piece);
    }
    isInRemainingPieces(piece) {
        const playerPieces = this.remainingPieces.get(piece.getPlayer());
        const numberOfPieces = playerPieces.get(piece.getSize()).getOrElse(0);
        return numberOfPieces > 0;
    }
}
export class EncapsuleSpace {
    pieces;
    static EMPTY = new EncapsuleSpace(new MGPMap());
    constructor(pieces) {
        this.pieces = pieces;
        this.pieces.makeImmutable();
    }
    getOccupiedCircles() {
        return this.pieces.filter(this.isEmptyKeyValue);
    }
    isEmpty() {
        const occupiedCircles = this.getOccupiedCircles();
        return occupiedCircles.size() === 0;
    }
    isEmptyKeyValue(_, value) {
        return value.isPlayer();
    }
    toList() {
        const pieces = [];
        for (const size of this.pieces.getKeyList()) {
            const player = this.pieces.get(size).get();
            if (player.isPlayer()) {
                const newPiece = EncapsulePiece.ofSizeAndPlayer(size, player);
                pieces.push(newPiece);
            }
        }
        return pieces;
    }
    getBiggest() {
        const occupiedCircles = this.getOccupiedCircles();
        const occupiedSizes = occupiedCircles.getKeyList();
        const sortedSizes = ArrayUtils.maximumsBy(occupiedSizes, (value) => value);
        if (sortedSizes.length === 0) {
            return EncapsulePiece.NONE;
        }
        else {
            const biggestSize = sortedSizes[0];
            const biggestPlayer = this.pieces.get(biggestSize).get();
            return EncapsulePiece.ofSizeAndPlayer(biggestSize, biggestPlayer);
        }
    }
    tryToSuperposePiece(piece) {
        const biggestPresent = this.getBiggest().getSize();
        if (piece === EncapsulePiece.NONE) {
            throw new Error('Cannot move EMPTY on a space');
        }
        if (piece.getSize() > biggestPresent) {
            return MGPOptional.of(this.put(piece));
        }
        else {
            return MGPOptional.empty();
        }
    }
    removeBiggest() {
        const removedPiece = this.getBiggest();
        if (removedPiece === EncapsulePiece.NONE) {
            throw new Error('Cannot remove piece from empty space');
        }
        const size = removedPiece.getSize();
        const removedPieces = this.pieces.getCopy();
        removedPieces.delete(size);
        removedPieces.makeImmutable();
        const removedSpace = new EncapsuleSpace(removedPieces);
        return { removedSpace: removedSpace, removedPiece };
    }
    put(piece) {
        if (piece === EncapsulePiece.NONE)
            throw new Error('Cannot put NONE on space');
        const biggest = this.getBiggest();
        Utils.assert(biggest.size < piece.size, 'Cannot put a piece on top of a bigger one');
        const addedPieces = this.pieces.getCopy();
        addedPieces.put(piece.getSize(), piece.getPlayer());
        addedPieces.makeImmutable();
        return new EncapsuleSpace(addedPieces);
    }
    belongsTo(player) {
        return this.getBiggest().getPlayer() === player;
    }
}
